import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=4065b060&scoped=true&"
import script from "./AddIcon.vue?vue&type=script&lang=js&"
export * from "./AddIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddIcon.vue?vue&type=style&index=0&id=4065b060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4065b060",
  null
  
)

export default component.exports